import styled from "styled-components";
import {CssRule} from "../../../themes/architecture/css-helpers/css-rule";

export const GameDetailsJpBox = styled.div`
    padding: 0 0 0.5rem 0;
    color:  ${props => props.theme.colors.jackpotValueColor};
    text-align: center;
    font-family: ${props => props.theme.font.family.ultra};
    font-size: 2.4em;
    font-weight: 800;

    ${CssRule.For.mobile.build()} & {
        font-size: 1.8rem;
    }
`;